import React from 'react'
import { Typography, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ActionButtons from './ActionButtons'

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: 10,
  },
  noMargin: {
    marginBottom: 0,
  },
}))

function CardHeader({ title, mode, setMode, action: fnAction, cancel: fnCancel, headingElement = 'h5', noMargin = false, buttons, btnParams }) {
  const classes = useStyles()

  return (
    <Grid container justifyContent='space-between' className={noMargin ? classes.noMargin : classes.root}>
      <Grid item>
        <Typography variant={headingElement}>
          {title}
        </Typography>
      </Grid>
      <Grid item>
        {setMode && <ActionButtons
          mode={mode}
          setMode={setMode}
          action={fnAction}
          cancel={fnCancel}
          {...btnParams}
        />}
        {buttons && buttons.map((button, i) => <React.Fragment key={i}>{button}</React.Fragment>)}
      </Grid>
    </Grid>
  );

}

export default CardHeader
